<template>
  <p class="text-danger-40 mt-2 text-sm">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "InputError",
};
</script>
